import { DownloadOutlined } from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import { secureApi } from '../../../hooks/api';
import { url } from '../../../constants/api';
import { useCrudRecord } from '../../../containers/crud/recordContext';

export const ExportWebsite = () => {
  const { key } = useCrudRecord();

  const onClick = async () => {
    try {
      const response = await secureApi(
        url(`website-configurations/${key}/refresh`)
      );

      // Create JSON blob and trigger download
      const blob = new Blob([JSON.stringify(response, null, 2)], {
        type: 'application/json',
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `website-${key}.json`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      message.success('Website has been exported successfully.');
    } catch (error) {
      message.error('Error while exporting website.');
    }
  };

  return (
    <Tooltip title="Export as JSON" placement="bottom">
      <Button className="btn blue-btn-text" onClick={onClick}>
        <DownloadOutlined />
      </Button>
    </Tooltip>
  );
};
